import sizeComparison from "assets/icons/illustration-multiple-sites.svg";
import Moving from "assets/images/psp/relatedContentImages/outdoor-rv.webp";
import Industry from "assets/images/psp/relatedContentImages/relocating-rv.webp";
import HowToStore from "assets/images/psp/relatedContentImages/rvstoragebanner.webp";
import General from "assets/images/psp/relatedContentImages/winter-road-warrior.webp";
import ctaMan from "assets/images/psp/inlineCTA.png";
import illustrationSearch from "assets/images/psps/illustration-search.svg";

import GeorgeRansom from "assets/images/review-george.png";
import AnnAlarcon from "assets/images/review-ann.png";
import SMurphy from "assets/images/review-murphy.png";
import Business from "assets/images/psp/richconentImages/business-2.webp";

export const sizeComparisonContent = {
	title: "Vehicle Storage Units",
	description:
		"Vehicle storage sizes range from 20 feet to 50 feet in length. Most cars will generally fit into a 10x20 unit, and most RVs and boats will generally fit into a 35-foot unit. Oversized vehicles or large Class A RVs may need a unit up to 50 feet long. Vehicle storage units often provide indoor parking spaces or covered outdoor parking to protect against the elements. Some storage facilities offer enclosed vehicle units.",
	image: sizeComparison,
	sizes: [
		{
			id: "10x15",
			label: "10x15",
			title: "10’ Wide x 15’ Long",
			description:
				" - Most compact and two-door cars, like hatchbacks, crossovers, and small SUVs, come in at just around 15 feet in length.\n" +
				" - Always make sure to measure your car before renting out a storage unit, it must be under 15 feet in length to fit in a 10'x15' unit.\n" +
				" - Because most cars fit into a 10' wide unit, most car storage facilities will not note the width on " +
				"their facility page."
		},
		{
			id: "10x20",
			label: "10x20",
			title: "10’ Wide x 20’ Long",
			description:
				" - Most cars are less than 20 feet long and will fit comfortable inside a 10x20 car storage unit.\n" +
				" - This includes SUVs, crossovers, sedans, minivans, pickup trucks, and most full-sized vans.\n" +
				" - Because most cars fit into a 10' wide unit, most car storage facilities will not note the width on " +
				"their facility page."
		},
		{
			id: "10x25",
			label: "10x25",
			title: "10’ Wide x 25’ Long",
			description:
				" - Perfect for larger vehicles or a boat.\n" +
				" - Small Class B campers, small Class C campers, travel trailers, toy trailers and pop-ups may also fit in spaces designed for RV storage."
		},
		{
			id: "10x30",
			label: "10x30",
			title: "10’ Wide x 30’ Long",
			description:
				" - Very few vehicle models require a 10'x30' storage unit, except for the largest trucks and vans.\n" +
				" - Storage units typically have a 8' to 10' tall ceiling, so if your truck is on larger wheels or on a lift kit, it may be too tall for some units. Always be sure to measure the height of larger cars.\n" +
				" - Because most cars fit into a 10' wide unit, most car storage facilities will not note the width on " +
				"their facility page."
		},
		{
			id: "10x35",
			label: "10x35",
			title: "10’ Wide x 35’ Long",
			description:
				" - Store one or multiple vehicles with plenty of other possessions, including furniture and large appliances.\n" +
				" - This size can typically contain large Class B and Class C campers, mid-to-large sized travel trailers, small-to-mid sized fifth-wheel campers, large toy trailers, and small Class A campers."
		},
		{
			id: "10x40",
			label: "10x40",
			title: "10’ Wide x 40’ Long",
			description:
				" - All but the largest of RVs will fit into a 40’ storage space. This includes most Class A campers, large " +
				"travel trailers and fifth-wheel trailers.\n" +
				" - Remember that with the added length often comes additional width and height, meaning that many of " +
				"these extra-large vehicles will require ceilings with a minimum height of 15 feet."
		},
		{
			id: "10x50",
			label: "10x50",
			title: "10’ Wide x 50’ Long",
			description:
				" - 50’ RV storage space will handle the largest of RVs, like large Class A campers, travel trailers " +
				"and destination trailers.\n" +
				" - Remember that with the added length often comes additional width and height, meaning that many of " +
				"these extra-large vehicles will require ceilings with a minimum height of 15 feet."
		}
	]
};

export const RelatedContentData = {
	heading: "Related Content",
	unitCards: [
		{
			category: "Moving Tips",
			url: "https://www.storage.com/blog/do-self-storage-facilities-offer-moving-truck-rentals/",
			date: "June 18, 2024",
			image: Moving,
			content:
				"Do Storage Facilities Offer Moving Truck Rentals? How to Get a Free Moving Truck with Your Storage Rental."
		},
		{
			category: "Industry Trends",
			url: "https://www.storage.com/blog/truck-trailer-storage-guide/",
			date: "June 18, 2024",
			image: Industry,
			content:
				"Truck and Trailer Storage Guide 2025: Costs, Options, and Tips for Every Vehicle."
		},
		{
			category: "How to Store It",
			url: "https://www.storage.com/blog/the-complete-guide-to-vehicle-storage/",
			date: "June 18, 2024",
			image: HowToStore,
			content:
				"Vehicle Storage: Where and How To Store a Car"
		},
		{
			category: "General Storage Advice",
			url: "https://www.storage.com/blog/10x20-storage-unit-size-guide/",
			date: "June 18, 2024",
			image: General,
			content:
				"The Ultimate 10×20 Storage Unit Size Guide"
		}
	]
};

export const InlineCTAContent = {
	storageType: "Vehicle",
	subheading: "Make a free reservation in minutes!",
	searchPlaceholder: "Search by city, state, or zip...",
	searchButtonText: "Find Storage",
	// image: ctaMan,
	backgroundColor: "white",
	imageAltText: "inlineCTA image"
};

export const faqContent = {
	title: "[STORAGE TYPE] Frequently Asked Questions",
	description:
		"These are the most common questions we get asked when people are trying to decide between storage unit sizes.",
	faqs: [
		{
			question: "How tall is a standard storage unit?",
			answer: "While storage unit heights at each facility will vary, the standard height of a storage unit tends to be around 8 feet tall. 10 feet and higher are available at select facilities."
		},
		{
			question: "What if I choose the wrong size?",
			answer: "This isn't all that uncommon. It can be hard to visualize how much space you need. If you have secured a storage unit that is inaccurately matched with what you plan to store, the facility manager can help find you the right storage unit size. Not only will they help you make the necessary changes in your rental agreement, but they will also assist you in determining the proper unit size suitable for your belongings."
		},
		{
			question: "How are storage units priced differently based on size?",
			answer: "The price you can expect to pay for each square foot of storage space is different at every facility, and is determined by your location, choice of unit features, and a number of other factors."
		},
		{
			question: "Do all storage unit sizes have the same amenities?",
			answer: "Smaller storage units can be interior or exterior. Smaller storage units are typically interior with options for climate control, while larger units are almost always exterior with drive-up access (climate control isn't very common with exterior storage units). Otherwise, security features are typically the same for units across the board at a given facility."
		}
	]
};

export const storageUnitSizeChartContent = {
	title: "Storage Unit Size Chart",
	description:
		"Use the storage unit sizes chart below to find the right size for your needs or personal property.",
	storages: [
		{
			title: "Locker",
			numerics:[ "15 ft²", "25 ft²"],
			bestFor: ["Miscellaneous items", "Studio Apartment", "Marketplace"]
		},
		{
			title: "5x5",
			numerics: ["25 ft²", "200 ft²"],
			bestFor: ["Miscellaneous items"]
		},
		{
			title: "5x10",
			numerics: ["50 ft²",  "400 ft²"],
			bestFor: ["Studio Apartment", "1-Bedroom Apartment", "Motorcycle"]
		},
		{
			title: "5x15",
			description: "Average Monthly Cost: $87.24",
			numerics: ["50 ft²",  "400 ft²"],
			bestFor: ["Studio Apartment", "1-Bedroom Apartment", "Motorcycle"]
		},
		{
			title: "10x10",
			numerics: ["100 ft²",  "800 ft²"],
			bestFor: ["2-Bedroom Apartment", "2-Bedroom House"]
		},
		{
			title: "10x15",
			numerics: ["150 ft²",  "1200 ft²"],
			bestFor: ["2-Bedroom Apartment", "2-Bedroom House"]
		},
		{
			title: "10x20",
			numerics: ["200 ft²",  "1600 ft²"],
			bestFor: ["2-Bedroom House", "Car"]
		},
		{
			title: "10x25",
			numerics: ["250 ft²",  "2000 ft²"],
			bestFor: ["3-Bedroom House"]
		},
		{
			title: "10x30",
			numerics: ["300 ft²",  "2400 ft²"],
			bestFor: ["4-Bedroom House",]
		},
		{
			title: "10x40",
			numerics: ["400 ft²",  "3200 ft²"],
			bestFor: ["4-Bedroom House",]
		},
		{
			title: "Security Gates & Cameras",
			numerics: [],
			bestFor: ["All storage scenarios", "Enhanced Security", "Peace of mind"]
		},
		{
			title: "Outdoor RV Storage",
			numerics: ["10x30",  "10x40", "10x50"],
			bestFor: ["Budget conscious owners", "Mild climates", "Short to medium-term storage"]
		},
		{
			title: "Vehicle Storage Spaces",
			numerics: ["$75-$110/month"],
			bestFor: ["Budget-conscious, covered PWCs", "Mild climates"]
		},
	]
};

export const contentSectionContent = {
	oneColumn: {
		title: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
		content: [
			{
				id: 1,
				value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu."
			},
			{
				id: 2,
				value: "Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit."
			},
			{
				id: 3,
				value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu."
			}
		],
		color: "blue",
		isColumnWise: false
	},
	threeColumn: {
		title: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
		content: [
			{
				id: 1,
				value: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu.`
			},
			{
				id: 2,
				value: `Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit.`
			},
			{
				id: 3,
				value: `Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.`
			}
		],
		isColumnWise: true,
		color: "light-blue"
	}
};

export const StickySearchHeaderContent = {
	title: "Find Cheap Storage Units Near You",
	buttonText: "Find Storage",
	id: "sticker-search-bar",
	label: "Search by zip..."
};

export const storageGridContent = {
	title: "More ways to store",
	image: illustrationSearch,
	storageTypes: [
	{
		id: "climate-controlled",
		image: sizeComparison,
		title: "Climate Controlled Storage",
		description:
			"Keep your belongings safe from extreme temperatures and humidity with climate-controlled units.",
		link: "/storage/climate-controlled/"
	},
	{
		id: "drive-up",
		image: Moving,
		title: "Drive-Up Storage",
		description:
			"Convenient ground-level access allows you to load and unload directly from your vehicle.",
		link: "/storage/drive-up/"
	},
	{
		id: "vehicle",
		image: Industry,
		title: "Vehicle Storage",
		description:
			"Secure parking spaces for cars, RVs, boats, and motorcycles with various size options.",
		link: "/storage/vehicle/"
	},
	{
		id: "indoor",
		image: HowToStore,
		title: "Indoor Storage",
		description:
			"Protected units inside a facility building, offering enhanced security and weather protection.",
		link: "/storage/indoor/"
	},
	{
		id: "outdoor",
		image: General,
		title: "Outdoor Storage",
		description:
			"Cost-effective storage solutions with exterior access, perfect for less sensitive items.",
		link: "/storage/outdoor/"
	},
	{
		id: "portable",
		image: ctaMan,
		title: "Portable Storage",
		description:
			"Flexible storage containers delivered to your location for ultimate convenience.",
		link: "/storage/portable/"
	},
	{
		id: "wine",
		image: sizeComparison,
		title: "Wine Storage",
		description:
			"Temperature and humidity-controlled units specifically designed for wine collections.",
		link: "/storage/wine/"
	},
	{
		id: "business",
		image: Moving,
		title: "Business Storage",
		description:
			"Commercial storage solutions for inventory, equipment, and business supplies.",
		link: "/storage/business/"
	}
]};

export const reviewsContent = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "Needed a space for a visiting cousin to park a car trailer for a four day visit. I called storage.com and they immediately found a space with great pricing close to our house. The reservation took less than 5 minutes and I got a call from the storage unit manager within 10 minutes. I was very grateful and relieved to be able to make these arrangements so easily. Thanks!",
			author: "George Ransom",
			title: "Storage.com is easy, quick, and responsive",
			imageSrc: GeorgeRansom
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Sydney M.",
			title: "Excellent Customer Service!",
			imageSrc: AnnAlarcon
		},
		{
			body: "Steve was very pleasant and helpful from the outset. I would have given him a 5 but the last star depends on the units and service on site and whether they provide a consistent experience. If they are like Steve, I am not worried.",
			author: "S. Murphy",
			title: "Very pleasant, helpful representative",
			imageSrc: SMurphy
		}
	]
};

export const RichContentData = {
	image: {
		title: "Lorem ipsum dolor sit amet consectetur adipiscing.",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu.",
		mediaType: "image",
		mediaUrl: Business,
		videoTitle: "",
	},
	video: {
		title: "Rich Content Section Example",
		description: "Most people store their motorhomes in the winter, but worry about [how to winterize an RV](https://storage.com/blog/winterize-your-rv/). Setting your camper up for storage success across all seasons is easier than you think. With just a few preparations and some forward thinking, you can safely store your RV so it’s ready for whatever adventure awaits.",
		mediaType: "video",
		mediaUrl: "enyJ_5ttrTc",
		videoTitle: "How to Winterize Your RV | Storage.com"
	}
};
